export const SUBMISSION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

/**
 * Registros de ejemplo (respuestas ya enviadas de un formulario). Sirven
 * para alimentar "Mis registros" (operativo), "Actividad" (analista) y
 * el detalle de reportes.
 *
 * @typedef {Object} Submission
 * @property {string} id
 * @property {string} formId
 * @property {string} formTitle
 * @property {string} submittedBy user id
 * @property {string} submittedByName
 * @property {string} submittedAt ISO datetime
 * @property {'pending'|'approved'|'rejected'} status
 * @property {string} location
 * @property {string} summary
 */

/** @type {Submission[]} */
export const SUBMISSIONS = [
  {
    id: 's1',
    formId: 'f1',
    formTitle: 'Encuesta de satisfacción ciudadana',
    submittedBy: 'u1',
    submittedByName: 'Camila Rojas',
    submittedAt: '2026-06-30T14:23:00',
    status: SUBMISSION_STATUS.PENDING,
    location: 'Bogotá · Zona Norte',
    summary: 'Calificación general: 4/5',
  },
  {
    id: 's2',
    formId: 'f3',
    formTitle: 'Registro de atención en salud comunitaria',
    submittedBy: 'u1',
    submittedByName: 'Camila Rojas',
    submittedAt: '2026-06-30T10:05:00',
    status: SUBMISSION_STATUS.APPROVED,
    location: 'Bogotá · Zona Norte',
    summary: '14 pacientes atendidos',
  },
  {
    id: 's3',
    formId: 'f2',
    formTitle: 'Visita de verificación de obra',
    submittedBy: 'u2',
    submittedByName: 'Julián Torres',
    submittedAt: '2026-06-29T16:40:00',
    status: SUBMISSION_STATUS.APPROVED,
    location: 'Medellín · Centro',
    summary: 'Avance de obra: 68%',
  },
  {
    id: 's4',
    formId: 'f5',
    formTitle: 'Censo de comerciantes informales',
    submittedBy: 'u2',
    submittedByName: 'Julián Torres',
    submittedAt: '2026-06-29T09:12:00',
    status: SUBMISSION_STATUS.REJECTED,
    location: 'Medellín · Centro',
    summary: 'Documentación incompleta',
  },
  {
    id: 's5',
    formId: 'f1',
    formTitle: 'Encuesta de satisfacción ciudadana',
    submittedBy: 'u3',
    submittedByName: 'Mariana Gil',
    submittedAt: '2026-06-28T18:02:00',
    status: SUBMISSION_STATUS.PENDING,
    location: 'Cali · Oriente',
    summary: 'Calificación general: 3/5',
  },
  {
    id: 's6',
    formId: 'f3',
    formTitle: 'Registro de atención en salud comunitaria',
    submittedBy: 'u3',
    submittedByName: 'Mariana Gil',
    submittedAt: '2026-06-27T13:47:00',
    status: SUBMISSION_STATUS.APPROVED,
    location: 'Cali · Oriente',
    summary: '9 pacientes atendidos',
  },
  {
    id: 's7',
    formId: 'f2',
    formTitle: 'Visita de verificación de obra',
    submittedBy: 'u1',
    submittedByName: 'Camila Rojas',
    submittedAt: '2026-06-26T11:30:00',
    status: SUBMISSION_STATUS.PENDING,
    location: 'Bogotá · Zona Norte',
    summary: 'Avance de obra: 42%',
  },
  {
    id: 's8',
    formId: 'f5',
    formTitle: 'Censo de comerciantes informales',
    submittedBy: 'u3',
    submittedByName: 'Mariana Gil',
    submittedAt: '2026-06-24T08:55:00',
    status: SUBMISSION_STATUS.APPROVED,
    location: 'Cali · Oriente',
    summary: '6 comerciantes censados',
  },
  {
    id: 's9',
    formId: 'f1',
    formTitle: 'Encuesta de satisfacción ciudadana',
    submittedBy: 'u2',
    submittedByName: 'Julián Torres',
    submittedAt: '2026-06-20T15:18:00',
    status: SUBMISSION_STATUS.REJECTED,
    location: 'Medellín · Centro',
    summary: 'Respuestas incompletas',
  },
  {
    id: 's10',
    formId: 'f6',
    formTitle: 'Reporte de mantenimiento de parques',
    submittedBy: 'u1',
    submittedByName: 'Camila Rojas',
    submittedAt: '2026-06-15T09:00:00',
    status: SUBMISSION_STATUS.APPROVED,
    location: 'Bogotá · Zona Norte',
    summary: 'Estado general: bueno',
  },
];
